import { featureEnabled } from 'utils';
import { startOfDay } from 'date-fns';

angular.module('bb.listing_search').component('bbAppointmentSearch', {
  bindings: {},
  controller: AppointmentSearchController,
  controllerAs: 'vm',
  template: require('./appointment_search.html'),
});

AppointmentSearchController.$inject = [
  '$location',
  '$routeParams',
  '$rootScope',
  'LS',
  'AppointmentSearchService',
  'UtilService',
  'ModalService',
  '$q',
];
function AppointmentSearchController(
  $location,
  $routeParams,
  $rootScope,
  LS,
  AppointmentSearchService,
  UtilService,
  ModalService,
  $q,
) {
  const vm = this;

  const chronologicalShowingsEnabled = featureEnabled('chronologicalShowings');

  vm.$onInit = () => {
    vm.dataLoaded = false;

    vm.auth = $rootScope.auth;

    vm.openContactDrawer = $rootScope.openContactDrawer;

    if ($routeParams.type === 'team') {
      vm.appointmentNames = 'My Team >';
    } else {
      vm.appointmentNames = 'My Business >';
    }

    vm.search = {
      searchType: $routeParams.type || 'team',
      dateFrom: $routeParams.dateFrom,
      dateTo: $routeParams.dateTo,
      sort_asc: $routeParams.sort_asc || chronologicalShowingsEnabled,
      sort_field: $routeParams.sort_field || 'time',
    };

    vm.pageNumber = $routeParams.pageNumber || 0;

    vm.pageNumberWidget = Number(vm.pageNumber) + 1;

    vm.statuses = [
      'pending',
      'new',
      'attempted',
      'confirm',
      'deny',
      'cancel',
      'time_change',
      'time_passed',
    ];

    vm.loadAppointments();

    vm.changePage = page => {
      vm.pageNumberWidget = page;
      vm.pageNumber = vm.pageNumberWidget - 1;
      vm.dataLoaded = false;
      vm.loadAppointments();
    };

    vm.sort = field => {
      if (vm.search.sort_field === field) {
        vm.search.sort_asc = `${!(vm.search.sort_asc === 'true')}`;
      } else {
        vm.search.sort_asc = 'true';
      }
      vm.search.sort_field = field;
      vm.dataLoaded = false;
      vm.loadAppointments();
    };
  };

  vm.showPreferencesModal = () => {
    if (!vm.preferences || !vm.preferences.statuses) {
      vm.clearPreferences();
    }
    const prefCopy = _.cloneDeep(vm.preferences);
    ModalService.openAppointmentFilterModal(prefCopy).then(
      ({ preferences, updated }) => {
        if (updated) {
          vm.preferences = preferences;
          vm.dataLoaded = false;
          vm.loadAppointments();
        }
      },
    );
  };

  vm.clearPreferences = () => {
    vm.preferences = {
      dateFrom: chronologicalShowingsEnabled
        ? startOfDay(new Date())
        : undefined,
      dateTo: undefined,
      statuses: {},
      team: 'All',
      sort_asc: chronologicalShowingsEnabled,
      sort_field: chronologicalShowingsEnabled ? 'time' : undefined,
    };
    vm.statuses.forEach(status => {
      vm.preferences.statuses[status] = true;
    });
  };

  vm.resetPreferences = () => {
    vm.clearPreferences();
    vm.dataLoaded = false;
    vm.loadAppointments();
  };

  vm.getSearchParams = () => {
    const search = _.cloneDeep(vm.search);

    search.type = vm.search.searchType;
    search.pageNumber = vm.pageNumber;
    if (!vm.preferences || !vm.preferences.statuses) {
      vm.clearPreferences();
    }
    const { statuses } = vm.preferences;
    search.preferences = Object.keys(statuses).filter(
      status => statuses[status] === true && status !== 'pending',
    );
    search.dateFrom = vm.preferences.dateFrom;
    search.dateTo = vm.preferences.dateTo;
    search.team = vm.preferences.team;
    search.includeConfirmedPendingAppointment =
      statuses.pending && !statuses.confirm;
    search.excludeConfirmedPendingAppointment =
      !statuses.pending && statuses.confirm;
    return search;
  };

  vm.loadAppointments = () => {
    if ($routeParams.type === 'team' && !$rootScope.hasFeature('TEAMS')) {
      vm.TeamFeatureNotIncluded = true;
    } else {
      vm.TeamFeatureNotIncluded = false;
    }
    // Stop loading if already loading
    if (vm.isLoading) return;
    vm.isLoading = true;

    AppointmentSearchService.searchAppointments(
      vm.getSearchParams(),
      featureEnabled('newListingsSearchAPI'),
    ).then(data => {
      const { appointments, isLimitedCount, count } = data;

      // prev/next for listings;
      const appointmentIds = appointments
        .map(appt => appt.appointment.id)
        .join(',');
      LS.setData('appointments', appointmentIds);

      vm.appointments = appointments;

      // pagination
      vm.totalAppointments = count;
      vm.isLimitedCount = isLimitedCount;

      if (!appointmentIds) {
        UtilService.getServerDate().then(({ date }) => {
          vm.serverDate = date;
          vm.isLoading = false;
          vm.dataLoaded = true;
        });
        return;
      }

      AppointmentSearchService.getPermissionsMany(appointmentIds).then(
        permissions => {
          vm.appointments = appointments.map(list => {
            const newAppt = _.cloneDeep(list);
            newAppt.permission = permissions[list.appointment.id];
            return newAppt;
          });

          vm.showButton = (appt, buttonStatus) => {
            const isHiddenAgent =
              appt.listing.hiddenReps &&
              appt.listing.hiddenReps.some(user => user === $rootScope.auth.id);

            const isListingAgent =
              appt.listing.reps &&
              appt.listing.reps.some(user => user === $rootScope.auth.id);

            if (isListingAgent || isHiddenAgent) {
              return appt.permission && appt.permission[buttonStatus];
            }
            return false;
          };

          UtilService.getServerDate().then(({ date }) => {
            vm.serverDate = date;
            vm.isLoading = false;
            vm.dataLoaded = true;
          });
        },
      );
    });
  };

  vm.viewListing = id => {
    $location.path(`listing/${id}/view`);
  };

  vm.downloadParams = () => {
    let paramUrl;
    if ($routeParams.type === 'team') {
      paramUrl = 'group=TeamDetails';
    } else {
      paramUrl = 'group=UserDetails';
    }
    if (vm.preferences.statuses) {
      Object.entries(vm.preferences.statuses).forEach(([status, val]) => {
        if (val) paramUrl += `&preferences=${status}`;
      });
    }
    if (vm.preferences.dateFrom)
      paramUrl += `&dateFrom=${vm.preferences.dateFrom.toISOString()}`;
    if (vm.preferences.dateTo)
      paramUrl += `&dateTo=${vm.preferences.dateTo.toISOString()}`;
    if (vm.preferences.team && vm.preferences.team !== 'All')
      paramUrl += `&teamId=${vm.preferences.team}`;
    if (vm.search.sort_asc) paramUrl += `&sortAsc=${vm.search.sort_asc}`;
    if (vm.search.sort_field) paramUrl += `&sortField=${vm.search.sort_field}`;
    return paramUrl;
  };

  vm.isFiltered = () => {
    if (vm.preferences.dateFrom || vm.preferences.dateTo) return true;
    const statusApplied = vm.statuses.filter(
      status => vm.preferences.statuses[status],
    );
    if (statusApplied.length !== vm.statuses.length) return true;
    return false;
  };

  vm.hasSupraRebrandingFeature = featureEnabled('supraRebrandingFeature', 1);
}

export {};
